import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import resources from '../translations'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en-HK', // set when external use
    fallbackLng: 'en-HK',
    keySeparator: '.', // we do not use keys in form messages.welcome
    contextSeparator: '__',
    pluralSeparator: '__',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
  })
